import { Pressable } from "react-native";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import { AppIcon } from "../AppIcon";
import Box from "../Box";

type Props = {
	label: string;
	onPress: () => void;
	disabled?: boolean;
	testID?: string;
};

const LockedOptionsBanner = ({ label, onPress, disabled, testID }: Props) => {
	const theme = useAppTheme();
	const foreground = theme.colors.onTertiaryContainer;

	return (
		<Pressable
			onPress={onPress}
			disabled={disabled}
			accessibilityRole="button"
			accessibilityLabel={label}
			accessibilityState={{ disabled }}
			style={{ opacity: disabled ? 0.5 : 1 }}
			testID={testID}
		>
			<Box
				flexDirection="row"
				alignItems="center"
				gap={12}
				paddingHorizontal={12}
				paddingVertical={12}
				borderRadius={theme.roundness * 2}
				backgroundColor={theme.colors.tertiaryContainer}
			>
				<AppIcon name="lock-outline" size={24} color={foreground} />
				<Text
					variant="bodyLarge"
					numberOfLines={2}
					style={{ flex: 1, color: foreground }}
				>
					{label}
				</Text>
				<AppIcon name="chevron-right" size={24} color={foreground} />
			</Box>
		</Pressable>
	);
};

export default LockedOptionsBanner;
